'use strict';
/* global instantsearch */
var hitTemplate =
  '<div class="card">'
    + '<a href="/{{uri}}">'
      + '<img class="card-img-top img-fluid {{cardstyle}}"'
        + ' src="{{thumbnail}}" alt="{{thumbnailAlt}}"'
        + ' srcset="{{thumbnailSmall}} 480w"'
        + ' sizes="100vw">'
    + '</a>'
    + '<div class="card-body">'
      + '<h4 class="card-title"><a href="/{{uri}}">{{title}}</a></h4>'
      + '<p class="card-text">{{summary}}</p>'
      + '<p class="card-text">'
        + '{{#showAffiliateButton}}'
          + '<a class="button" href="{{affiliateUrl}}">'
            + '<i class="fa fa-shopping-cart" aria-hidden="true"></i> {{affiliateButtonText}}'
          + '</a>'
        + '{{/showAffiliateButton}}'
        + '{{^showAffiliateButton}}'
          + '<small class="text-muted">Posted in '
          + '{{#categoryList}}'
          + '<a href="/categories/{{link}}">{{tag}}</a>, '
          + '{{/categoryList}}'
          + '{{^categories}}'
          + '<a href="/{{section}}">{{sectionUpperCase}}</a>'
          + '{{/categories}}'
          + '{{#showExtraSection}}'
          + ' with other <a href="/{{section}}">{{sectionUpperCase}}</a>'
          + '{{/showExtraSection}}'
          + '</small>'
        + '{{/showAffiliateButton}}'
      + '</p>'
    + '</div>'
  + '</div>';

var noResultsTemplate =
  '<div>' +
    '<h4>Oopsey</h4>' +
    '<p>Uh oh. The mommy bird isn\'t home. Try to find her by looking in one of these other places or use the search bar above.</p>' +
    '<a href="/recipes/pizza-pinwheels/">pizza pinwheels</a><br/>' +
    '<a href="/blog/how-to-make-your-couch-purple/">DIY purple sofa</a><br/>' +
    '<a href="/recipes/vegan-butterfinger-cupcakes/"/>butterfinger cupcakes</a>' +
    '<a href="/recipes/breakfast-bird-nests"/><img src="/images/birds-nests.jpg"></a>' +
  '</div>';


function titleCase(str) {
    return str.toLowerCase().split(/\s|-/).map(function(word) {
      return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

function transformHit(hit) {
  hit.summary = hit.description || hit.content.substring(0, 30);

  if (hit.categories) {
    hit.showExtraSection = true;
    hit.categoryList = [];
    for (let i = 0; i < hit.categories.length; i++) {
      let section = hit.categories[i];
      hit.categoryList.push({tag: titleCase(section), link: section.replace(' ', '-')})
    }
  }

  if (hit.section == "store") {
    hit.showAffiliateButton = true;
  }

  if (!hit.affiliateButtonText) {
    if (hit.affiliatebuttontext) {
      hit.affiliateButtonText = hit.affiliatebuttontext;
    } else {
      hit.affiliateButtonText = "Buy on Amazon";
    }
  }

  if (!hit.thumbnailSmall && hit.thumbnail) {
    hit.thumbnailSmall = hit.thumbnail;
    if (!hit.thumbnailSmall.startsWith("https://") && hit.thumbnailSmall.endsWith(".jpg")) {
      var parts = hit.thumbnailSmall.split(".jpg");
      hit.thumbnailSmall = parts[0] + "-480w.jpg";
    }
  }

  if (hit.section) {
    hit.sectionUpperCase = titleCase(hit.section);
  } else {
    console.log(hit);
  }

  return hit;
}

$(function() {

var search = instantsearch({
  appId: 'RLCL4VE0EZ',
  apiKey: '47fb42290972cd97c017e8097f27ffd6',
  indexName: 'vegandollhouse',
  urlSync: true,
  searchFunction: function(helper) {
    if (helper.state.query !== '') {
      helper.search();
      $("#hits").removeClass("hidden");
    } else {
      $("#hits").addClass("hidden");
    }
  },
  searchParameters: {
    hitsPerPage: 100,
  }
});

search.addWidget(
  instantsearch.widgets.searchBox({
    container: document.querySelector('#q'),
    placeholder: 'Search Vegan Dollhouse',
    poweredBy: false,
    reset: false,
    autofocus: true,
    magnifier: false,
    loadingIndicator: false
  })
);

search.addWidget(
  instantsearch.widgets.hits({
    container: document.querySelector('#hits'),
    templates: {
      empty: noResultsTemplate,
      item: hitTemplate
    },
    transformData: {
      item: transformHit
    },
    cssClasses: {
      root: "card-columns",
      empty: "main content about no-columns",
    }
  })
);

  search.start();
});
